if (!customElements.get("image-hotspots")) {
  class ImageHotspots extends HTMLElement {
    constructor() {
      super();

      this.buttons.forEach((button) => {
        button.addEventListener("click", () => {
          this.onHotspotClick(button);
        });
      });

      this.onHotspotClick(this.buttons[0]);
    }

    get buttons() {
      return this.querySelectorAll(".image-hotspots__button[data-target]");
    }

    get hotspotContent() {
      return this.querySelectorAll(".image-hotspots__hotspot-content");
    }

    onHotspotClick(button) {
      const id = button.getAttribute("data-target");

      this.setButtonsInactive();

      button.classList.add("image-hotspots__button--active");

      this.hotspotContent.forEach((contentElement) => {
        contentElement.classList.toggle(
          "image-hotspots__hotspot-content--visible",
          contentElement.id === id
        );
      });
    }

    setButtonsInactive() {
      this.buttons.forEach((button) =>
        button.classList.remove("image-hotspots__button--active")
      );
    }
  }

  customElements.define("image-hotspots", ImageHotspots);
}
